<div id="tui-image-editor" style="height: 100%"></div>
